// import ResizableBox from "../ResizableBox";
import React, {useEffect, useRef, useState} from "react";
import CanvasJSReact from '../canvasjs.react';
import DropableLabel from "./DropableLabel";
import CorrectIcon from "../images/CorrectIcon.svg"
import InCorrectIcon from "../images/incorrectIcon.svg"
import "animate.css/animate.css";
import questionsAnswers from "../containers/questionAnswers"
import supplyIcon from "../images/Supply.svg"
import SocialCost from "../images/Social-cost.svg"
import DemandIcon from "../images/Demand.svg"
import { Input, InputAdornment } from "@material-ui/core";
import { styled } from "@material-ui/core/styles";
import Labels from "./Labels";
import { Grid, Typography } from "@material-ui/core";
import styles from "./BubbleLine1Styles";
import withStyles from "@material-ui/core/styles/withStyles";
import { isMobile, isTablet } from "react-device-detect";

var _ = require('lodash');

var CanvasJSChart = CanvasJSReact.CanvasJSChart;
// var CanvasJS = CanvasJSReact.CanvasJS;

const BubbleAndLine3 = (props) => {
  const [answerCoordinates, setAnswerCoordinates] =useState([{style: {}, XYPoint: {}}])
  const [allCorrect, setAllCorrect] =useState(false)
  const [xLabel, setXLabel] =useState("")
  const [yLabel, setYLabel] =useState("")
  const { qIndex, handleReloadClick, classes } = props;
  const [chartData, setChartData] =useState([])
  const [bubbleData, setBubbleData] =useState([])
  const [bubbleColor, setBubbleColor] =useState('#8C479B')
  const [submit, setSubmit] =useState(false)
  const [isYes, setIsYes] = useState(null)
  const [reRender, setReRender] = useState(false)
  const [buyAmount, setBuyAmount] = useState("");
  const canvasRef = useRef(null);
  const [canvasWidth, setCanvasWidth] = useState(0);
  const [buyerTax, setBuyerTax] = useState(0)
  const [sellerTax, setSellerTax] = useState(0)
  const [socialCost, setSocialCost] = useState(0)

  const handleChange = (event) => {
    setBuyAmount(event.target.value);
  };

  const StyledInputAdornment = styled(InputAdornment)({
    '& .MuiTypography-root': {
      color: "red", // This targets the Typography inside the InputAdornment
    },
  });
  

  let data = [
    {
      type: "line",
      color: 'transparent',
      dataPoints: []
    },
    {
      type: "scatter",
      color: 'transparent',
      markerSize: isMobile? 10 : 25,
      dataPoints: []//.concat.apply([], my_w)
    },
    {
      type: "scatter",
      markerSize: isMobile? 10 : 25,
      color: bubbleColor,
      dataPoints: bubbleData
    },
    {
      type: "spline",
      color: bubbleColor,
      lineThickness: isMobile ? 3 : 5,
      dataPoints: [{x: 10, y: 16, cursor: 'pointer', z: 3}, {x: 50, y: 20, cursor: 'pointer', z: 3}, {x: 150, y: 30, cursor: 'pointer', z: 3}, {x: 250, y: 40, cursor: 'pointer', z: 3}, {x: 290, y: 44, cursor: 'pointer', z: 3}]
    },
    {
      type: "scatter",
      markerSize: isMobile? 10 : 25,
      color: '#003e4c',
      dataPoints: []
    },
    {
      type: "spline",
      color: '#003e4c',
      lineThickness: isMobile ? 3 : 5,
      dataPoints: [{x: 10, y: 6, cursor: 'pointer', z: 1}, {x: 50, y: 10, cursor: 'pointer', z: 1}, {x: 150, y: 20, cursor: 'pointer', z: 1}, {x: 250, y: 30, cursor: 'pointer', z: 1}, {x: 290, y: 34, cursor: 'pointer', z: 1}]
    },
    {
      type: "spline",
      color: '#00b1d9',
      lineThickness: isMobile ? 3 : 5,
      dataPoints: [{x: 10, y: 34, cursor: 'pointer', z: 1000}, {x: 100, y: 25, cursor: 'pointer', z: 1000}, {x: 200, y: 15, cursor: 'pointer', z: 1000}, {x: 250, y: 10, cursor: 'pointer', z: 1000}, {x: 290, y: 6, cursor: 'pointer', z: 1000}]
    },
    {
      type: "line",
      lineThickness: isMobile ? 3 : 5,
      lineDashType: "shortDash",
      color: '#003e4c',
      dataPoints: []
    },
    {
      type: "line",
      lineThickness: isMobile ? 3 : 5,
      lineDashType: "shortDash",
      color: '#003e4c',
      dataPoints: []
    },
  ]


  // window.addEventListener("resize", () => setTimeout(() => {
  //   setReRender(!reRender)
  //   setCanvasWidth(document.getElementsByClassName("canvasjs-chart-canvas")[0].style.width)
  //   return window.removeEventListener("resize", () => {
  //   })
  // }, 50));

  useEffect(() => {
    setChartData(data)
    console.log(document.getElementsByClassName("canvasjs-chart-canvas")[0].style.width)
    // setCanvasWidth(document.getElementsByClassName("canvasjs-chart-canvas")[0].style.width)
  }, [])

  useEffect(() => {
    if(submit === true){
      setAllCorrect(buyerTax === 20 && sellerTax === 20 && socialCost === 30 && isYes === false)
      if(buyerTax === 20 && sellerTax === 20 && socialCost === 30 && isYes === false){
        data[7].dataPoints = [{x: 0, y: 30, z: 3}, {x: 150, y: 30, z: 3}, {x: 150, y: 0, z: 3}]
        data[8].dataPoints = [{x: 0, y: 20, z: 3}, {x: 150, y: 20, z: 3}]
        setChartData(data)
      }
    }
  },[submit])

  const options = {
    colorSet: "colorSet2",
    cursor: "pointer",
    title: {
      text: isMobile ? "" : "Supply of Snow Globes",
      fontColor: "#transparent",
      // fontColor: "#003e4c",
      fontFamily: "Rubik",
      fontWeight: "bold",
      fontSize: 24,
    },
     axisX:{
      lineColor: "#003e4c",
      lineThickness: 3,
      gridThickness: 1,
      gridColor: "#cecece",
      labelFontColor: "#003e4c",
      labelFontSize: isMobile ? 12 : 16,
      // labelFontWeight: "bold",
      labelFontFamily: "Rubik",
      interval: questionsAnswers[qIndex].step,
      minimum: 0,
      maximum: questionsAnswers[qIndex].xmax,
    },
    axisY:{
      lineColor: "#003e4c",
      lineThickness: 3,
      labelFontSize: isMobile ? 12 : 16,
      // labelFontWeight: "bold",
      labelFontFamily: "Rubik",
      gridThickness: 1,
      labelFontColor: "#003e4c",
      gridColor: "#cecece",
      interval:  questionsAnswers[qIndex].stepY,
      minimum: 0,
      maximum: questionsAnswers[qIndex].ymax,
      margin: 10
      // title: " asdas",
    },
    toolTip: {
      enabled: false,
    },
    data: chartData,
    height: isMobile && 200,
    width: isMobile && 320
  }

  function getButtonText() {
    if(submit){
      return allCorrect ? "Next" : "Try Again"
    }else{
      return "Submit"
    }
  }

  const clearScreen = () => {
    setSubmit(false)
    setBuyerTax(0)
    setSocialCost(0)
    setIsYes(0)
    setSellerTax(0)
  }

  function submitButtonAction() {
    if(submit){
      if(!allCorrect){
        clearScreen()
      }
    }else{
      setSubmit(true)
    }
  }

  return (
      <>
      <div className={classes.mainContainer3}>
        <div className={classes.leftContainer3}>
          <div className={classes.innerContainer3}>
           <div className={classes.parentDiv3}>
            <h3 className={classes.titleText3}>{questionsAnswers[qIndex].question}</h3>
            <div className={`animate__animated animate__bounceIn ${classes.optionContainer3}`}>

              <div className={`animate__animated animate__bounceIn ${classes.optionGrid3}`}>
                <p className={classes.firstOption3}>What is the value to buyers of the 150<sup>th</sup> unit of denim?</p>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <button className={classes.incrementButton3} disabled={buyerTax === 0 || submit} onClick={() => setBuyerTax(buyerTax-5)}><b>-</b></button>
                  <p className={classes.valueText3} style={{ color: submit ? buyerTax === 20 ? "green" : "red" : "#043e4b" }}>${buyerTax}</p>
                  <button className={classes.incrementButton3} disabled={submit} onClick={() => setBuyerTax(buyerTax+5)}><b>+</b></button>
                </div>

                <p className={classes.firstOption3}>What is the cost to sellers to produce the 150<sup>th</sup> unit of denim?</p>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <button className={classes.incrementButton3} disabled={sellerTax === 0 || submit} onClick={() => setSellerTax(sellerTax-5)}><b>-</b></button>
                  <p className={classes.valueText3} style={{ color: submit ? sellerTax === 20 ? "green" : "red" : "#043e4b" }}>${sellerTax}</p>
                  <button className={classes.incrementButton3} disabled={submit} onClick={() => setSellerTax(sellerTax+5)}><b>+</b></button>
                </div>

                <p className={classes.firstOption3}>What is the social cost of producing the 150<sup>th</sup> unit of denim?</p>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <button className={classes.incrementButton3} disabled={socialCost === 0 || submit} onClick={() => setSocialCost(socialCost-5)}><b>-</b></button>
                  <p className={classes.valueText3} style={{ color: submit ? socialCost === 30 ? "green" : "red" : "#043e4b" }}>${socialCost}</p>
                  <button className={classes.incrementButton3} disabled={submit} onClick={() => setSocialCost(socialCost+5)}><b>+</b></button>
                </div>

                <p className={classes.firstOption3}>
                  Is it socially optimal for the market to produce the 150<sup>th</sup> ton of denim?
                </p>
                <div style={{ display: "flex", alignItems: "center", width: "50%", justifyContent: "space-evenly" }}>
                  <button className={classes.yesNoOption3} style={{  backgroundColor: submit ? isYes === true ? "red" : "#043e4b" : isYes === true ? "#00b1d9" : "#043e4b" }} disabled={submit} onClick={() => setIsYes(true)}><b>Yes</b></button>
                  <button className={classes.yesNoOption3} style={{  backgroundColor: submit ? isYes === false ? "green" : "#043e4b" : isYes === false ? "#00b1d9" : "#043e4b" }} disabled={submit} onClick={() => setIsYes(false)}><b>No</b></button>
                </div>

              </div>
            </div>
           </div>
          </div>
        </div>
        {/* <Grid style={{position: "relative" }}>
          { submit && allCorrect &&
            <Labels canwidth={canvasWidth}/>
          }
        </Grid> */}
        <div className={`animate__animated animate__bounceIn ${classes.rightContainer}`}>
        {/* <Labels /> */}
          <DropableLabel
            right={'-20%'}
            marginTop={isMobile ? "10%" : "25%"}
            rotate={"rotate(270deg)"}
            label={"PRICE"}
          />
          <p className={classes.graphTitle}>{questionsAnswers[qIndex].title}</p>

          <img src={SocialCost} alt="" className={classes.socialCostIcon} />
          <img src={supplyIcon} alt="" className={classes.supplyIcon} />
          <CanvasJSChart options = {options}  ref={canvasRef}/>
          <DropableLabel
            right={"75%"}
            marginTop={"0%"}
            rotate={"rotate(0deg)"}
            label={"QUANTITY"}
          />
          <img src={DemandIcon} alt="" className={classes.demandIcon}/>
          {/* {submit && (getLabeltext() || getAnswertext()) &&
            <div style={{ display: "flex", top: 0, height: "78%", width: "100%", position: "absolute", zIndex: 1, background: "rgba(152, 152, 152, 0.5)" }}>
            </div>
          } */}
        </div>
      </div>
      <Grid container className={classes.correctAnswerContainer3}>
        <Grid container style={{ width: allCorrect ? isMobile ? "85%" : "80%" : "50%" }}>
          {submit && !allCorrect ?
            <div style={{ display: "flex", alignItems: "center" }}>
              <img src={InCorrectIcon} alt="InCorrectIcon" className={classes.icon} />
            </div>
          : submit &&
          <Grid container style={{ width: "95%" }}>
              {/* <img src={CorrectIcon} alt="CorrectIcon" style={{ height: 50, float: 'left', marginTop: '60px' }}/> */}
              <img src={CorrectIcon} alt="CorrectIcon" className={classes.icon} />
              <Typography className={classes.answerText3}>
              To determine each value, go up vertically from the quantity given, and then read across to find the corresponding price or value. The <b>value to buyers</b> is given by the height of the demand curve at the 150<sup>th</sup> unit. The <b>cost to sellers</b> is given by the height of the supply curve at the 150<sup>th</sup> unit. The <b>total social cost</b> is given by the height of the social cost curve at the 150<sup>th</sup> unit. <i>Since the social cost exceeds the value it is not optimal to produce the 150<sup>th</sup> unit</i>.
              </Typography>
          </Grid>
          }
        </Grid>

        <Grid container style={{ width: allCorrect ? isMobile ? '12%' : '20%' : '50%', justifyContent: 'start' }}>
          {
          getButtonText() !== 'Next' ? (<>
            <button className={classes.submitButtom} onClick={() => submitButtonAction()}>{getButtonText()}</button>
            <button className={classes.submitButtom} style={{color: "#00b1d9", marginLeft: 20, backgroundColor: '#fff' }} onClick={() => clearScreen()}>Clear</button>
            </>) : <button className={classes.submitButtom} onClick={() => handleReloadClick()}>{getButtonText()}</button>
          }
        </Grid>
      </Grid>
    </>
  )

}
export default withStyles(styles)(BubbleAndLine3);
